import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import ImgBox from '@blade-sxp/tools/components/img-box.vue';
import Result from '@blade-sxp/tools/pages/one-n/components/result.vue';
import { getlibraries } from '@blade-sxp/tools/apis';
import { Status } from '@blade-sxp/tools/interfaces';
let Tools = class Tools extends Vue {
    status = Status.Init;
    Status = Status;
    form = {
        sourceImage: {},
        libIdList: [],
        threshold: '',
    };
    librariesList = [];
    localStorageParam = '';
    get disabled() {
        if (Object.keys(this.form.sourceImage).length === 0)
            return true;
        if (this.form.libIdList.length === 0)
            return true;
        if (!this.form.threshold)
            return true;
        return false;
    }
    handleStatusChange(val) {
        val && this.changeStatus(Status.Init);
    }
    submit() {
        this.$refs['oneToOnForm'].validate((valid, reason) => {
            if (valid) {
                this.$refs['result'].pagination.page = 1;
                return this.$refs['result']?.search();
            }
        });
    }
    reset() {
        this.changeStatus(Status.Init);
        this.$refs['oneToOnForm']?.resetFields();
    }
    changeStatus(status) {
        this.status = status;
    }
    handleThreshold(val) {
        if (val) {
            val = val.replace(/([^0-9])/g, '');
            if (Number(val) < 1 || Number(val) > 99) {
                this.$message.warning(`${this.$t('numberRange')}`);
                this.form.threshold = '';
            }
        }
    }
    getlibraries() {
        getlibraries({})
            .then((resp) => {
            this.librariesList = resp.list;
        })
            .catch((err) => {
            this.$message.error({ message: err, type: 'error' });
        });
    }
    mounted() {
        this.localStorageParam = localStorage.getItem('param') || '';
        if (this.localStorageParam) {
            const routeData = JSON.parse(this.localStorageParam);
            // if (routeData.objectId) {
            this.$set(this.form.sourceImage, 'value', routeData.img);
            // }
            localStorage.setItem('param', '');
        }
        this.getlibraries();
    }
};
__decorate([
    Watch('disabled')
], Tools.prototype, "handleStatusChange", null);
Tools = __decorate([
    Component({
        name: 'faceOne2N',
        components: { ImgBox, Result },
        i18n: {
            messages: {
                en: {
                    portrait: 'Select Portrait',
                    library: 'Select portrait library',
                    threshold: 'Similarity threshold',
                    result: 'Search Results',
                    reset: 'Reset',
                    search: 'Search',
                    choseLibrary: 'Please select a portrait Library',
                    chosePortrait: 'Please select a portrait',
                    whiteThreshold: 'Please fill in the similarity threshold',
                    selectLibrary: '5 portrait galleries can be selected at the same time',
                    numberRange: 'Please enter a number between 1 and 99',
                },
                zh: {
                    portrait: '选择人像',
                    library: '选择人像库',
                    threshold: '相似度阈值',
                    result: '检索结果',
                    reset: '重置',
                    search: '检索',
                    choseLibrary: '请选择人像库',
                    chosePortrait: '请选择人像',
                    whiteThreshold: '请填写相似度阈值',
                    selectLibrary: '可同时选择5个人像库',
                    numberRange: '请输入1~99之间的数字',
                },
            },
        },
    })
], Tools);
export default Tools;
